import React from "react";
import { SxStyleProp } from "theme-ui";
import Text from "../Text/Text";

interface Props {
  sx?: SxStyleProp;
  children?: string;
  substring?: string;
}

const Highlight: React.FunctionComponent<Props> = ({
  children = "",
  substring = "",
  ...restProps
}) => {
  const beginString = children.substring(0, children.indexOf(substring));
  const endString = children.substring(
    beginString.length + substring.length,
    children.length,
  );
  let newChildren: string | React.ReactElement = children;
  if (substring.length && children.includes(substring)) {
    newChildren = (
      <React.Fragment>
        {beginString}
        <strong>{substring}</strong>
        {endString}
      </React.Fragment>
    );
  }

  return <Text {...restProps}>{newChildren}</Text>;
};

export default Highlight;
